import React from "react";

const RoundCTA = (props) => {
  const {size = 60, className = "", style = {}, children, ...additionalProps} = props;

  return <div
    className={`
      circle-container
      flex
      flex-direction-column
      align-items-center
      justify-content-center
      ${className}
    `}
    style={{
      width: `${size}px`,
      height: `${size}px`,
      ...style
    }}
    {...additionalProps}
  >
    {children}
  </div>;
};

export default RoundCTA;
